import React from 'react';
import HazardRatingGrid from './HazardRatingGrid';

const HazardRating = () => {
    return (
        <>
            <HazardRatingGrid />
        </>
    );
};

export default HazardRating;
